import { render, staticRenderFns } from "./OrgPage.vue?vue&type=template&id=5c45d561&"
import script from "./OrgPage.vue?vue&type=script&lang=js&"
export * from "./OrgPage.vue?vue&type=script&lang=js&"
import style0 from "./OrgPage.vue?vue&type=style&index=0&id=5c45d561&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports